// extracted by mini-css-extract-plugin
export default {"purchase-view__text":"LootboxPurchaseProgress_purchase-view__text__GOdNA","purchase-view__text-animated":"LootboxPurchaseProgress_purchase-view__text-animated__6LsbZ"};